import React, { Component } from "react";
import { connect } from "react-redux";

import {
  fetchHighlightAction,
  updateHighlightAction,
} from "actions/highlightAction";

import { toggleFullPageSpinner, toggleNotification } from "actions/toggle";

import Form from "pages/HighlightAction/Form";

class HighlightActionEdit extends Component {
  componentDidMount() {
    const { match, fetchHighlightAction } = this.props;
    const id = match.params.highlightActionId;
    fetchHighlightAction(id);
  }

  shapedDefaultValuesStructure() {
    const { ...rest } = this.props.highlightAction.data;

    return Object.assign(
      {},
      {
        ...rest,
      }
    );
  }

  updateHighlightAction(id, data) {
    const {
      toggleNotification,
      toggleFullPageSpinner,
      updateHighlightAction,
      history,
    } = this.props;

    toggleFullPageSpinner(true);

    updateHighlightAction(id, data)
      .then(() => {
        toggleNotification(true, {
          message: "Updated HighlightAction Success",
          infoClassName: "is-success",
        });
        history.push(`/highlight-actions`);
      })
      .catch((e) => {
        toggleNotification(true, {
          message: e.message,
          infoClassName: "is-danger",
        });
      })
      .then(() => toggleFullPageSpinner(false));
  }

  handleFormSubmit = (data) => {
    const id = this.props.match.params.highlightActionId;

    this.updateHighlightAction(id, data);
  };

  render() {
    const { highlightAction } = this.props;

    if (highlightAction.loading) {
      return "loading";
    }
    const defaultValues = this.shapedDefaultValuesStructure();
    return (
      <Form
        handleFormSubmit={this.handleFormSubmit}
        defaultValues={defaultValues}
      />
    );
  }
}

const mapStateToProps = ({ highlightAction }) => ({
  highlightAction,
});

export default connect(mapStateToProps, {
  fetchHighlightAction,
  updateHighlightAction,
  toggleFullPageSpinner,
  toggleNotification,
})(HighlightActionEdit);



// WEBPACK FOOTER //
// ./src/pages/HighlightAction/Edit/index.js